import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { delay } from 'rxjs/operators';
import { StageSetup, StageSetupParams } from '../../interfaces/career-setup/stage-setup.interface';
import { CommonSearchParam } from '../../interfaces/common-search-param.interface';
import { PageResponse } from '../../interfaces/page-response.interface';
import { StageSetupService } from './stage-setup.service';

@Injectable({
  providedIn: 'root'
})
export class StageSetupMockService extends StageSetupService {
  private mockData: StageSetup[] = [
    { uniqueId: 'stage-1', roleUniqueId: 'role-fe', name: 'Initial Screening', type: 'PRE_ASSESSMENT', description: 'Preliminary evaluation of profile', orderNo: 1, active: true },
    { uniqueId: 'stage-2', roleUniqueId: 'role-fe', name: 'Coding Challenge', type: 'CODING_ROUND', description: 'Take-home coding assignment', orderNo: 2, active: true },
    { uniqueId: 'stage-3', roleUniqueId: 'role-be', name: 'System Design', type: 'CODING_ROUND', description: 'Scalability and architecture discussion', orderNo: 1, active: true },
    { uniqueId: 'stage-4', roleUniqueId: 'role-be', name: 'HR Round', type: 'FACE_TO_FACE', description: 'Soft skills and behavioral check', orderNo: 2, active: true }
  ];

  constructor() {
    super();
  }

  getStages(params: StageSetupParams): Observable<StageSetup[]> {
    let filtered = this.mockData;
    if (params.roleUniqueId) {
      filtered = filtered.filter(s => s.roleUniqueId === params.roleUniqueId);
    }
    return of(filtered).pipe(delay(500));
  }

  override findAll(params: CommonSearchParam): Observable<PageResponse<StageSetup>> {
    let filtered = this.mockData;
    if (params.searchTerm) {
      filtered = filtered.filter(s => s.name.toLowerCase().includes(params.searchTerm!.toLowerCase()));
    }
    const pageResponse: PageResponse<StageSetup> = {
      content: filtered,
      page: { number: 0, size: filtered.length, totalElements: filtered.length, totalPages: 1 }
    };
    return of(pageResponse).pipe(delay(500));
  }

  override find(id: string): Observable<StageSetup> {
    const stage = this.mockData.find(s => s.uniqueId === id);
    return of(stage!).pipe(delay(300));
  }

  override create(data: Partial<StageSetup>): Observable<StageSetup> {
    const newStage: StageSetup = {
      ...data as StageSetup,
      uniqueId: `stage-${Date.now()}`
    };
    this.mockData.push(newStage);
    return of(newStage).pipe(delay(300));
  }

  override update(id: string, data: Partial<StageSetup>): Observable<StageSetup> {
    const index = this.mockData.findIndex(s => s.uniqueId === id);
    if (index > -1) {
      this.mockData[index] = { ...this.mockData[index], ...data };
      return of(this.mockData[index]).pipe(delay(300));
    }
    throw new Error('Stage not found');
  }

  override updateStatus(id: string, isActive: boolean): Observable<StageSetup> {
    const index = this.mockData.findIndex(s => s.uniqueId === id);
    if (index > -1) {
      this.mockData[index] = { ...this.mockData[index], active: isActive };
      return of(this.mockData[index]).pipe(delay(300));
    }
    throw new Error('Stage not found');
  }

  override delete(id: string): Observable<void> {
    this.mockData = this.mockData.filter(s => s.uniqueId !== id);
    return of(undefined).pipe(delay(300));
  }
}
